import script from "./LocationIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationIcon.vue?vue&type=script&setup=true&lang=ts"

import "./LocationIcon.vue?vue&type=style&index=0&id=b15fa8ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b15fa8ae"]])

export default __exports__